import React from "react";
import copyIcon from "../../assets/icons/content_copy.svg";
import { bnkAccount } from "../../Variable";



const PointChargeSummary: React.FC = () => {
    return (
        <>
        <div className="mt-5">
            <div className=""></div>
            <div className="flex justify-between px-5 py-2 leading-[23px] border-t-[1px] border-[#A6A7AB] border-solid">
                <div>
                    <span className="font-semibold">30 만원</span>
                    <span> 구매 시</span>
                </div>
                <div>
                    <span className="font-semibold">300,000 AP포인트</span>
                    <span> 적립</span>
                </div>
            </div>
            <hr />
            <div className="flex justify-between px-5 py-2 leading-[23px] border-[##A6A7AB] border-solid">
                <div>
                    <span className="font-semibold">50 만원</span>
                    <span> 구매 시</span>
                </div>
                <div>
                    <span className="font-semibold">500,000 AP포인트</span>
                    <span> 적립</span>
                </div>
            </div>
            <hr />
            <div className="flex justify-between px-5 py-2 leading-[23px]">
                <div>
                    <span className="font-semibold">100 만원</span>
                    <span> 구매 시</span>
                </div>
                <div>
                    <span className="text-[14px] text-middleGray02">+5% 추가&nbsp;&nbsp;&nbsp;</span>
                    <span className="font-semibold">1,050,000 AP포인트</span>
                    <span> 적립</span>
                </div>
            </div>
            <hr />
            <div className="flex justify-between px-5 py-2 leading-[23px] border-[##A6A7AB] border-solid">
                <div>
                    <span className="font-semibold">200 만원</span>
                    <span> 구매 시</span>
                </div>
                <div>
                    <span className="text-[14px] text-middleGray02">+7% 추가&nbsp;&nbsp;&nbsp;</span>
                    <span className="font-semibold">2,140,000 AP포인트</span>
                    <span> 적립</span>
                </div>
            </div>
            <hr />
            <div className="flex justify-between px-5 py-2 leading-[23px] border-b-[1px] border-[#A6A7AB] border-solid">
                <div>
                    <span className="font-semibold">300 만원</span>
                    <span> 구매 시</span>
                </div>
                <div>
                    <span className="text-[14px] text-middleGray02">+10% 추가&nbsp;&nbsp;&nbsp;</span>
                    <span className="font-semibold">3,300,000 AP포인트</span>
                    <span> 적립</span>
                </div>
            </div>
        </div>
        <div className="h-[140px] border-[0.5px] border-middleGray02 border-solid rounded-[5px] mx-auto mt-4 text-center relative">
            <img
                onClick={async () => {
                    try {
                        await navigator.clipboard.writeText("부산은행 113-2011-0981-05");
                        alert('복사가 성공했습니다.');
                    }
                    catch (e) {
                        alert('복사가 실패되었습니다.');
                    }
                }} className="absolute top-3 right-3 cursor-pointer" src={copyIcon} alt=""
            />
            <h1 className="mt-7 text-[20px] font-semibold">
                {bnkAccount[0]}
            </h1>
            <p className="my-3 text-[20px] font-light">
                {bnkAccount[1]}
            </p>
            <div className="px-5">
                <hr />
            </div>
            <div className="flex justify-between px-5 pt-[10px] text-[16px]">
                <span className="font-light">전화번호</span>
                <span className="font-semibold">051-558-1317</span>
            </div>
        </div>
        </>
    )
};

export default PointChargeSummary;